import { useCallback } from 'react';
import { TrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import UsersAndTeamsSelect from '../../users-and-teams/components/UsersAndTeamsSelect';
import { useShowFooter } from '../hooks/useShowFooter';
import { RoutingMethodTooltip } from './RoutingMethodTooltip';
import RuleBox from './RuleBox';
import UnassignedSeatsBanner from './UnassignedSeatsBanner';
import { HELPDESK } from '../../shared/constants/workspaces';
import ManageSeatsBanner from './ManageSeatsBanner';
import AgentSelectItem from '../../users-and-teams/components/AgentSelectItem';
import { jsx as _jsx } from "react/jsx-runtime";
const renderFooter = (showFooter, showManageSeatsFooter, onClose) => {
  if (!showFooter) {
    return undefined;
  }
  return showManageSeatsFooter ? /*#__PURE__*/_jsx(ManageSeatsBanner, {
    onClose: onClose
  }) : /*#__PURE__*/_jsx(UnassignedSeatsBanner, {
    onClose: onClose
  });
};
const RoundRobinRow = ({
  routingRules,
  currentUser,
  disabled,
  FormControl,
  inboxId,
  isLoading,
  onUserOrTeamSelect = () => {},
  onUsersAndTeamsMount = () => {},
  selectedTeamIds,
  selectedUserIds,
  teamsOptions,
  teamTree,
  userAndTeamSelectValueComponent,
  usersAndTeamsSelectError,
  usersOptions,
  trackUsage = () => {},
  showLabel = true,
  hasRoutingAccess,
  workSpace,
  isUngatedForHelpDeskRoutingScopeFiltering
}) => {
  const {
    showFooter,
    dismissFooter
  } = useShowFooter(currentUser);
  const isNewSeatingModel = isUngatedForHelpDeskRoutingScopeFiltering && workSpace === HELPDESK;
  const errorMessage = usersAndTeamsSelectError ? 'routing-ui.routingRules.roundRobin.selectUserOrTeam' : undefined;
  const ItemComponent = useCallback(props => /*#__PURE__*/_jsx(AgentSelectItem, Object.assign({
    isOptionItemInDropdown: true,
    isNewSeatingModel: isNewSeatingModel,
    trackUsage: trackUsage
  }, props)), [isNewSeatingModel, trackUsage]);
  return /*#__PURE__*/_jsx(TrackUsageContext.Provider, {
    value: trackUsage,
    children: /*#__PURE__*/_jsx(RuleBox, {
      FormControl: FormControl,
      showLabel: showLabel,
      className: "roundRobinRow",
      tooltip: /*#__PURE__*/_jsx(RoutingMethodTooltip, {
        routingRules: routingRules
      }),
      tooltipProps: {
        maxWidth: 271
      },
      children: /*#__PURE__*/_jsx(UsersAndTeamsSelect, {
        disabled: disabled || !hasRoutingAccess,
        dropDownFooter: renderFooter(showFooter, isNewSeatingModel, dismissFooter),
        error: errorMessage,
        handleChange: onUserOrTeamSelect,
        hideUserSectionTooltip: isNewSeatingModel,
        inboxId: inboxId,
        isLoading: isLoading,
        itemComponent: ItemComponent,
        onMount: onUsersAndTeamsMount,
        selectedTeamIds: selectedTeamIds,
        selectedUserIds: selectedUserIds,
        teamsOptions: teamsOptions,
        teamTree: teamTree,
        usersOptions: usersOptions,
        valueComponent: userAndTeamSelectValueComponent
      })
    })
  });
};
RoundRobinRow.displayName = 'RoundRobinRow';
export default RoundRobinRow;